var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { removeBankAccountStart, removeBankAccountSucceeded, removeBankAccountFailed, } from "./bankAccount.actions";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
var getExtraDefaultState = function () { return ({
    removeBankAccount: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(removeBankAccountStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { removeBankAccount: __assign(__assign({}, state.removeBankAccount), (_a = {}, _a[payload.id] = __assign(__assign({}, state.removeBankAccount[payload.id]), { pending: true, error: undefined }), _a)) });
});
reducer.on(removeBankAccountSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { removeBankAccount: __assign(__assign({}, state.removeBankAccount), (_a = {}, _a[payload.id] = __assign(__assign({}, state.removeBankAccount[payload.id]), { pending: false, result: payload.result, error: undefined }), _a)) });
});
reducer.on(removeBankAccountFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { removeBankAccount: __assign(__assign({}, state.removeBankAccount), (_a = {}, _a[payload.id] = __assign(__assign({}, state.removeBankAccount[payload.id]), { pending: false, error: payload.error }), _a)) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
